import list from './list.js'

var index = {
    data() {
        return {

        }
    },
    fetch() {

    },
    modules: {
        list
    }
}

export default index;